import { atom } from "recoil";
import { INewDeepLinkEvidence, IParapassQuizData } from "@interfaces/Interfaces";

export const parapassTimelineDataAtom = atom<IParapassQuizData | null>({
  key: "parapassTimelineDataAtom",
  default: null,
  effects: [
    ({ onSet, setSelf }) => {
      setSelf(null);

      onSet((newValue, _oldValue, isReset) => {
        if (isReset) {
          return null;
        } else if (newValue !== undefined) {
          return newValue;
        }
      });
    },
  ],
});

export const learningLoopDeeplinkDataAtom = atom<INewDeepLinkEvidence | null>({
  key: "learningLoopDeeplinkDataAtom",
  default: null,
  effects: [
    ({ onSet, setSelf }) => {
      setSelf(null);

      onSet((newValue, _oldValue, isReset) => {
        if (isReset) {
          return null;
        } else if (newValue !== undefined) {
          return newValue;
        }
      });
    },
  ],
});
